import { render, staticRenderFns } from "./disadvantagedDetail.vue?vue&type=template&id=50adb147&"
import script from "./disadvantagedDetail.vue?vue&type=script&lang=js&"
export * from "./disadvantagedDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports